import Menu, { MenuProps } from '@mui/material/Menu'
import { styled } from '@mui/material/styles'

export const StyledDropdown = styled((props: MenuProps) => <Menu {...props} />)(() => ({
  '& .MuiPaper-root': {
    background: 'var(--glass-bg)',
    backdropFilter: 'var(--glass-blur)',
    WebkitBackdropFilter: 'var(--glass-blur)',
    boxShadow: 'var(--glass-shadow)',
    borderRadius: 'var(--radius-md)',
    border: 'var(--glass-border)',
    marginTop: '4px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  '& .MuiList-root': {
    padding: '5px 0',
    overflowY: 'auto',
    flex: '1 1 auto',
  },
}))
